import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../assets/icon/成员.png'
import _imports_1 from '../../assets/icon/客服.png'
import _imports_2 from '../../assets/icon/扫描.png'
import _imports_3 from '../../assets/icon/下载.png'


const _hoisted_1 = { class: "box-container" }
const _hoisted_2 = { class: "box-menu" }
const _hoisted_3 = ["onClick"]

import { ref } from 'vue';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'boxBottom',
  setup(__props) {

const list = ref([
  { value: 0, label: '山东省神经科学学会会员入口' },
  { value: 1, label: '山东省阿尔茨海默病防治协会会员入口' },
  { value: 2, label: '联系我们' },
  { value: 3, label: '微信二维码' },
  { value: 4, label: '下载专区' },
]);

// 会员入口跳转（前两个按钮）
const gotoMenberManagement = (item: any) => {
  if (item.value === 0) {
    window.location.href = 'https://member.tiemeeting.com/3/Mpersonal/Account/Login';
    return;
  }
  sessionStorage.removeItem('phone');
  sessionStorage.removeItem('numberIdx');
  router.push({
    path: `/menberLogin`,
    query: { id: item.value }
  });
};

// 联系我们跳转
const gotolianxi = () => {
  router.push('/learnOpen');
};

// 二维码页面跳转
const gotoQRCodePage = () => {
  router.push('/weixin'); // 替换为你的二维码页面路由
};
// 下载专区
const gotodown = () => {
  router.push('/learnZone'); // 替换为你的二维码页面路由
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("h2", { class: "title" }, "功能模块")
    ], -1)),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value.slice(0, 2), (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "box-menu-item",
          key: i,
          onClick: ($event: any) => (gotoMenberManagement(item))
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(item.label), 1)
        ], 8, _hoisted_3))
      }), 128)),
      _createElementVNode("div", {
        class: "box-menu-item",
        onClick: gotolianxi
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("img", { src: _imports_1 }, null, -1)),
        _createElementVNode("span", null, _toDisplayString(list.value[2].label), 1)
      ]),
      _createElementVNode("div", {
        class: "box-menu-item",
        onClick: gotoQRCodePage
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("img", { src: _imports_2 }, null, -1)),
        _createElementVNode("span", null, _toDisplayString(list.value[3].label), 1)
      ]),
      _createElementVNode("div", {
        class: "box-menu-item",
        onClick: gotodown
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("img", { src: _imports_3 }, null, -1)),
        _createElementVNode("span", null, _toDisplayString(list.value[4].label), 1)
      ])
    ])
  ]))
}
}

})